/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `PAID` - PAID
* `REFUNDED` - REFUNDED
* `PAST_DUE` - PAST_DUE
* `SCHEDULED` - SCHEDULED
* `PROCESSING` - PROCESSING
* `FAILED` - FAILED
* `RETRY` - RETRY
* `REVERSED` - REVERSED
* `CANCELED` - CANCELED
 */
export type PaymentsLogStatusEnum = typeof PaymentsLogStatusEnum[keyof typeof PaymentsLogStatusEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentsLogStatusEnum = {
  PAID: 'PAID',
  REFUNDED: 'REFUNDED',
  PAST_DUE: 'PAST_DUE',
  SCHEDULED: 'SCHEDULED',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
  RETRY: 'RETRY',
  REVERSED: 'REVERSED',
  CANCELED: 'CANCELED',
} as const;
